export const ADD = "ADD";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const UPLOAD = "UPLOAD";
